module.exports = __webpack_public_path__ + "vi.svg?3efbe9d7a56999baf92b0a6f2d6306eb";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/vi.svg
// module id = 1415
// module chunks = 27